import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { PhoneIcon } from '../../../../assets';
import { DateHelper, renderRecordValue } from '../../../../utils';
import { Button } from '../../../formControls/Button/Button';
import { STATUSES_STYLING } from '../../../../constants/styles/statuses';
import { GRACE_PERIOD_FOR_WAIT_TIME, RIDE_STATUSES, UBER_TEXT } from '../../../../constants/constants';
import { statusesDictionary } from '../../../../dictionaries';
import { Record } from '../RideDetails';
import { RIDE_STATUS_MODALS_TYPES } from '../../../../pages/TC_Admin/TC_RideDetails/RideStatusModal';
import {
  extractUberPhoneDigits,
  formatUberPhoneForDisplay,
  formatDuration,
  getRideStatusLabel,
  getUberDriverWaitMinutesForDetails,
  renderPhoneNumber,
} from '../../../../utils/helpers';
import { USER_ROLES } from '../../../../constants/constants';
import styles from '../index.module.css';
import { CancellationRideUserInfo } from './CancellationRideUserInfo';

export const RideStatusInfo = ({
  riderInfo,
  driver,
  status,
  vehicleType,
  readableStatus: readableStatusProp,
  showFullInfo,
  handleRideStatusModal,
  startDate,
  endDate,
  rideWaitTime,
  driverWaitTimeMinutes,
  driverArrivalTime,
  endRideComment,
  isTCWorker,
  isHOWorker,
  isMHAdmin,
  cancellationInfo,
  unableToFulfillInfo,
  declineInfo,
  timezone,
  role,
  isReRequested,
  uberInfo,
}) => {
  const readableStatus = readableStatusProp || statusesDictionary[status] || status;

  const showRideStartedInfo =
    readableStatus === statusesDictionary[RIDE_STATUSES.IN_PROGRESS] ||
    readableStatus === statusesDictionary[RIDE_STATUSES.COMPLETED];

  // const [showArrivalButton, setShowArrivalButton] = useState(false);
  // const [showStartButton, setShowStartButton] = useState(false);  

  
  //   if (
  //     readableStatus === statusesDictionary[RIDE_STATUSES.ACCEPTED] &&
  //     isTCWorker
  //   ) {
  //     console.log('Check for accepted ride button selection');
  //     if (!driverArrivalTime) {
  //       setShowStartButton(false);
  //       setShowArrivalButton(true);
  //     } else {
  //       setShowStartButton(true);
  //       setShowArrivalButton(false);
  //     }
  //   }
  

  const showEditStartButton =
    readableStatus === statusesDictionary[RIDE_STATUSES.IN_PROGRESS] &&
    readableStatus !== statusesDictionary[RIDE_STATUSES.COMPLETED] &&
    isTCWorker;

  const showRideEndedInfo = readableStatus === statusesDictionary[RIDE_STATUSES.COMPLETED];

  const showRideEndedButton = readableStatus === statusesDictionary[RIDE_STATUSES.IN_PROGRESS] && isTCWorker;

  const showAssignedDriver = isTCWorker && driver;

  const showHOMatchedDriverInfo = (isHOWorker || isMHAdmin) && driver;

  const showHOMatchedDriverEmail = isMHAdmin && driver;
  
  const showArrivalButton = readableStatus === statusesDictionary[RIDE_STATUSES.ACCEPTED] && isTCWorker && !driverArrivalTime;
  
  const showStartButton = readableStatus === statusesDictionary[RIDE_STATUSES.ACCEPTED] && isTCWorker && !!driverArrivalTime;

  const showCancellationInfo = cancellationInfo && readableStatus === statusesDictionary[RIDE_STATUSES.CANCELED];
  
  const showUnableToFulfillInfo =
    unableToFulfillInfo && (role === USER_ROLES.SUPER_ADMIN || readableStatus === statusesDictionary[RIDE_STATUSES.UNABLE_TO_FULFILL]);
  const showDeclineInfo = declineInfo && readableStatus === statusesDictionary[RIDE_STATUSES.DECLINED];

  let rideStatus = readableStatus;

  const isUberRide = vehicleType === 'uberAmbulatoryRide';

  const uberPhoneDigits = extractUberPhoneDigits({
    phoneValue: driver?.phoneNumber || uberInfo?.driver?.phone || uberInfo?.driverInfo?.phone,
    emailValue: driver?.email || uberInfo?.driver?.email,
  });

  const driverPhoneForDisplay = isUberRide && uberPhoneDigits
    ? formatUberPhoneForDisplay(uberPhoneDigits)
    : renderPhoneNumber(driver?.phoneNumber);
  const driverPhoneForHref = isUberRide
    ? (uberPhoneDigits ? `+${uberPhoneDigits}` : '')
    : renderPhoneNumber(driver?.phoneNumber);

  if (showCancellationInfo) {
    rideStatus = `Canceled`;
  }

  const driverWaitMins = getUberDriverWaitMinutesForDetails({
    uberInfo,
    waitTime: rideWaitTime,
    driverWaitTimeMinutes,
  });

  const showNoShowAndWaitOnUnableToFulfill =
    readableStatus === statusesDictionary[RIDE_STATUSES.UNABLE_TO_FULFILL] &&
    driverWaitMins !== null &&
    !Number.isNaN(driverWaitMins);
  const showNoDriversOnExpiredUber =
    readableStatus === statusesDictionary[RIDE_STATUSES.EXPIRED] &&
    vehicleType === 'uberAmbulatoryRide';

  const statusLabel = getRideStatusLabel(rideStatus, RIDE_STATUSES.CANCELED);

  const statusValue = showNoShowAndWaitOnUnableToFulfill ? (
    <>
      <span className={STATUSES_STYLING[readableStatus]}>
        {renderRecordValue(statusLabel)}
      </span>
      <span className={styles.noShowDriverWaitRed}>
        {` - No Show | Driver wait ${driverWaitMins} ${driverWaitMins === 1 ? 'Min' : 'Mins'}`}
      </span>
    </>
  ) : showNoDriversOnExpiredUber ? (
    <>
      <span className={STATUSES_STYLING[readableStatus]}>
        {renderRecordValue(statusLabel)}
      </span>
      <span className={styles.noShowDriverWaitRed}>
        {` - ${UBER_TEXT.NO_DRIVERS_AVAILABLE}`}
      </span>
    </>
  ) : (
    statusLabel
  );
  // console.log('showFullInfo', showFullInfo);
  // console.log('showAssignedDriver', showAssignedDriver);
  // console.log('isTCWorker', isTCWorker);'
 
  
  return (
    
    <div className={classNames({
            [styles.rideStatusInfoSpace] : !isTCWorker
          })}>
      {showFullInfo && showAssignedDriver ? (
        <p>
          Driver
          <span className={STATUSES_STYLING[readableStatus]}>{` ${driver?.firstName} ${driver?.lastName} `}</span>
          assigned
        </p>
      ) : (
        showFullInfo && isTCWorker && <p className={styles.noDriver}>No Driver was assigned to this Ride yet </p>
      )}

      {showHOMatchedDriverInfo && (
        <p className={styles.driverMatched}>
          Matched with driver
          <span className={STATUSES_STYLING[readableStatus]}>{` ${driver?.firstName} ${driver?.lastName} `}</span>
          {showHOMatchedDriverEmail && (
            <a href={`mailto:${driver?.email}`} className={styles.link}>
              {driver?.email}
            </a>
          )}
          {(isUberRide ? !!uberPhoneDigits : !!driver?.phoneNumber) && (
            <span className={STATUSES_STYLING[readableStatus]}>
              <a
                className={classNames({
                  [styles.phoneLink]: true,
                  [styles.driverPhone]: true,
                })}
                href={`tel:${driverPhoneForHref}`}>
                {driverPhoneForDisplay}
                <PhoneIcon fill="#E1F4D3" stroke="#1C452B" className={styles.phoneIcon} width={16} height={16} />
              </a>
            </span>
          )}
        </p>
      )}

      {(uberInfo?.driverInfo?.vehicleMake || uberInfo?.driverInfo?.vehicleModel || uberInfo?.driverInfo?.licensePlate) && (
        <p className={styles.driverMatched}>
          Vehicle Info:{' '}
          {[
            uberInfo.driverInfo.vehicleMake && <span key="make"><b>Make:</b> {uberInfo.driverInfo.vehicleMake}</span>,
            uberInfo.driverInfo.vehicleModel && <span key="model"><b>Model:</b> {uberInfo.driverInfo.vehicleModel}</span>,
            uberInfo.driverInfo.licensePlate && <span key="plate"><b>No. Plate:</b> {uberInfo.driverInfo.licensePlate}</span>,
          ].filter(Boolean).reduce((acc, el) => acc.length ? [...acc, ' | ', el] : [el], [])}
        </p>
      )}
      <Record
        title="Status"
        value={(showNoShowAndWaitOnUnableToFulfill || showNoDriversOnExpiredUber) ? statusValue : renderRecordValue(statusValue)}
        valueClassName={
          (showNoShowAndWaitOnUnableToFulfill || showNoDriversOnExpiredUber) ? undefined : STATUSES_STYLING[readableStatus]
        }
        myClassName={classNames({
          [styles.status]: !showFullInfo,
          [styles.statusFullInfo]: readableStatus === statusesDictionary[RIDE_STATUSES.CANCELED],
        })}
      />
      { showRideStartedInfo && !isHOWorker && driverArrivalTime && (
        <div className={classNames(styles.startDateInfo, styles.rideStatusInfoSpace)}>
          <Record
            title="Driver Arrived"
            myClassName={styles.startDateText}
            value={renderRecordValue(
              driverArrivalTime?.datetime &&
                driverArrivalTime?.timezone &&
                DateHelper.renderDateTimeWithTZ({
                  dateTime: driverArrivalTime?.datetime,
                  timeZone: driverArrivalTime?.timezone,
                })
            )}
          />

          {showEditStartButton && (
            <div>
              <Button
                myClassName={styles.editTimeBtn}
                onClick={handleRideStatusModal(true, RIDE_STATUS_MODALS_TYPES.DRIVER_ARRIVED)}>
                Edit Driver Arrived Time
              </Button>
            </div>
          )}
        </div>
        )
      }

      {showRideStartedInfo && (
        <div className={styles.startDateInfo}>
          <Record
            title="Ride started"
            myClassName={styles.startDateText}
            value={renderRecordValue(
              startDate.datetime &&
                startDate.timezone &&
                DateHelper.renderDateTimeWithTZ({
                  dateTime: startDate.datetime,
                  timeZone: startDate.timezone,
                })
            )}
          />

          {showEditStartButton && (
            <div>
              <Button
                myClassName={styles.editTimeBtn}
                onClick={handleRideStatusModal(true, RIDE_STATUS_MODALS_TYPES.EDIT_RIDE)}>
                Edit start time
              </Button>
            </div>
          )}
        </div>
      )}

      {showFullInfo &&
        (showRideEndedButton || showRideEndedInfo || showStartButton || showArrivalButton) && (
          <div className={styles.statusBtns}>
            {showRideEndedButton ? (
              <div>
                <Button
                  onClick={handleRideStatusModal(
                    true,
                    RIDE_STATUS_MODALS_TYPES.END_RIDE
                  )}
                >
                  Ride Ended
                </Button>
              </div>
            ) : (
              <div>
                {showRideEndedInfo ? (
                  <>
                    <Record
                      title="Ride ended"
                      myClassName={styles.startDateText}
                      value={renderRecordValue(
                        endDate.datetime &&
                          endDate.timezone &&
                          DateHelper.renderDateTimeWithTZ({
                            dateTime: endDate.datetime,
                            timeZone: endDate.timezone,
                          })
                      )}
                    />
                    {endRideComment && (
                      <div className={styles.driverComment}>
                        <span className={styles.recordTitle}>
                          Driver's comment:
                        </span>
                        <span>{endRideComment}</span>
                      </div>
                    )}

                    {rideWaitTime && (
                      <Record
                        title="Ride Wait Time"
                        myClassName={styles.waitTimeText}
                        value={formatDuration((Number(rideWaitTime) + + GRACE_PERIOD_FOR_WAIT_TIME) * 60)}
                      />
                    )}
                  </>
                ) : (
                  <>
                    {showArrivalButton ? (
                      <Button myClassName={styles.arrivalBtn}
                        onClick={handleRideStatusModal(
                          true,
                          RIDE_STATUS_MODALS_TYPES.DRIVER_ARRIVED
                        )}
                      >
                        Driver Check-In
                      </Button>
                    ) : (
                      showStartButton && (
                        <Button
                          onClick={handleRideStatusModal(
                            true,
                            RIDE_STATUS_MODALS_TYPES.START_RIDE
                          )}
                        >
                          Ride Started
                        </Button>
                      )
                    )}
                  </>
                )}
              </div>
            )}
          </div>
        )}

      {showUnableToFulfillInfo && (
        <div className={styles.cancellationInfoContainer}>
          <Record
            title='Date/Time ride request status changed to "Unable to Fulfill"'
            myClassName={styles.startDateText}
            value={renderRecordValue(
              unableToFulfillInfo?.createdAt &&
                DateHelper.renderDateTimeWithTZ({
                  dateTime: unableToFulfillInfo.createdAt,
                  timeZone: timezone,
                })
            )}
          />
          {unableToFulfillInfo.user && (
            <Record
              title='User name that changed status to "Unable to Fulfill"'
              value={renderRecordValue(
                `${unableToFulfillInfo.user.firstName} ${unableToFulfillInfo.user.lastName}`
              )}
              myClassName={styles.recordSection}
            />
          )}
          {unableToFulfillInfo.organization && !isTCWorker && (
            <Record
              title="Transportation Company associated with ride request"
              value={renderRecordValue(
                `${unableToFulfillInfo.organization.name}`
              )}
              myClassName={styles.recordSection}
            />
          )}
          {unableToFulfillInfo.comment && (
            <Record
              title="Unable to fulfill reason"
              value={renderRecordValue(unableToFulfillInfo.comment)}
              myClassName={styles.recordSection}
            />
          )}
        </div>
      )}


      {showCancellationInfo && cancellationInfo.organizationType !== 'Admin'  && (
        <div className={styles.cancellationInfoContainer}>
          {cancellationInfo?.createdAt && (
            <Record
              title="Date/Time of Cancellation"
              myClassName={styles.cancelation}
              value={renderRecordValue(
                cancellationInfo?.createdAt &&
                  DateHelper.renderDateTimeWithTZ({
                    dateTime: cancellationInfo.createdAt,
                    timeZone: timezone,
                  })
              )}
            />
          )}
          <Record
            title="Canceled By"
            myClassName={styles.cancelation}
            value={CancellationRideUserInfo({
              cancellationInfo,
              riderInfo,
              role,
            })}
          />
          {cancellationInfo?.comment && (
            <Record
              title="Reason of Cancellation"
              myClassName={styles.cancelation}
              value={renderRecordValue(cancellationInfo?.comment)}
            />
          )}
        </div>
      )}
      
      {showDeclineInfo &&
        declineInfo.map((declineRecord) => (
          <div
            className={styles.cancellationInfoContainer}
            key={declineRecord?.createdAt}
          >
            <Record
              title="Date/Time ride was declined"
              myClassName={styles.startDateText}
              value={renderRecordValue(
                declineRecord.createdAt &&
                  DateHelper.renderDateTimeWithTZ({
                    dateTime: declineRecord.createdAt,
                    timeZone: timezone,
                  })
              )}
            />
            {declineRecord.user && (
              <Record
                title="User name that declined the ride"
                value={renderRecordValue(
                  `${declineRecord.user.firstName} ${declineRecord.user.lastName}`
                )}
                myClassName={styles.recordSection}
              />
            )}
            {declineRecord.comment && (
              <Record
                title="Reason ride was declined"
                value={renderRecordValue(declineRecord.comment)}
                myClassName={styles.recordSection}
              />
            )}
          </div>
        ))}
    </div>
  );
};

RideStatusInfo.propTypes = {
  riderInfo: PropTypes.object,
  driver: PropTypes.object,
  status: PropTypes.string,
  vehicleType: PropTypes.string,
  readableStatus: PropTypes.string,
  showFullInfo: PropTypes.bool,
  handleRideStatusModal: PropTypes.func,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  rideWaitTime: PropTypes.object,
  driverArrivalTime: PropTypes.object,
  isTCWorker: PropTypes.bool,
  isHOWorker: PropTypes.bool,
  isMHAdmin: PropTypes.bool,
  isReRequested: PropTypes.bool,
  driverWaitTimeMinutes: PropTypes.number,
  uberInfo: PropTypes.object,
};
